export const convertCentsToDollars = (cents: number) => {
    return cents / 100;
};
